import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditSubscriptionTypeData {
  // Pre-filled values when opening the subscription type form for editing.

  name: string
  // Plan name.

  durationDays: number
  // Validity in days.

  numberOfServices: number | null
  // Visit cap; null for an unlimited plan.

  price: number | null
  // Current catalog price in major units; null when none is set.

  businessServiceTypeIds: string[]
  // Covered service type ids.
}

export const useAddSubscriptionTypeFormStore = defineStore('addSubscriptionTypeForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditSubscriptionTypeData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditSubscriptionTypeData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddSubscriptionTypeFormStore, import.meta.hot))
}
